import { useQuery } from '@tanstack/react-query';
import { appelApi } from './api';

export interface TacheFacturation {
  id: string;
  titre: string;
  sousTitre: string;
  statut: string;
  ton: 'danger' | 'warning' | 'info';
  page: string;
  site: string;
}

export interface DonneesFacturation {
  compteurs: {
    aFacturer: { nombre: number; detail: string };
    aEmettre: number;
    aEnvoyer: number;
    enRetard: { nombre: number; texte: string };
    resteDu: { nombre: number; texte: string };
  };
  taches: TacheFacturation[];
}

/**
 * Tableau de bord du pôle facturation (TF-424) : les compteurs de « Financeurs
 * & OPCO » et de « Factures », et ce qui attend un geste.
 */
export function useDashboardFacturation(site: string) {
  const parametres = site && site !== 'TOUS' ? `?site=${encodeURIComponent(site)}` : '';
  return useQuery({
    // Sous « financements » : chaque geste du pôle (préparer, émettre, régler…) l'actualise.
    queryKey: ['financements', 'tableau-de-bord', parametres],
    queryFn: () => appelApi<DonneesFacturation>(`/dashboard/facturation${parametres}`),
  });
}
